.client-information-entry{line-height:35px!important}.client-information-entry-container{height:35px}.client-information-key{display:inline-block;width:100px}
/*# sourceMappingURL=client-information-entry.component-EX52Z6DZ.css.map */
